import { Color, Flex, Range, Radios, Text } from "src/elements";
import { RulesSectionContainer } from "./RulesSectionContainer";

// The mudmap penalty multipliers are relative weights summed into one solver
// objective: what matters is their ratio to each other, and pogger puts no
// bound on them. A 0–100 track parked several defaults — and every 100 in the
// vertical-blocking preset — on its ceiling, so "weigh this more" could not be
// expressed. 200 is pogger's own largest default (coreRangeSpaceSlack) and
// leaves headroom above the preset while keeping one shared scale.
export const MUDMAP_WEIGHT_SLIDER_MAX = 200;

interface SliderCardProps<T> {
  title: string;
  description: string;
  parentRadioConfig?: {
    options: Array<{ label: string; value: T }>;
    selection: T;
    onSelect: (value: T) => void;
  };
  sliderValue: number;
  onSliderChange: (value: number) => void;
  isDisabled?: boolean;
  area: string;
  leftLabel?: string;
  rightLabel?: string;

  path?: string | readonly string[];
  /** Upper bound of the track. Defaults to MUDMAP_WEIGHT_SLIDER_MAX. */
  max?: number;
}

export const SliderCard = <T,>({
  area,
  title,
  description,
  parentRadioConfig,
  sliderValue,
  onSliderChange,
  isDisabled,
  leftLabel = "Allow",
  rightLabel = "Disallow",
  path,
  max = MUDMAP_WEIGHT_SLIDER_MAX,
}: SliderCardProps<T>) => (
  <RulesSectionContainer title={title} area={area} isDisabled={isDisabled} path={path}>
    <Flex column gap="10px">
      {parentRadioConfig && (
        <Radios
          options={parentRadioConfig.options}
          value={parentRadioConfig.selection}
          setValue={parentRadioConfig.onSelect}
          isDisabled={isDisabled}
          direction="row"
        />
      )}
      <Text variant="small2" color={isDisabled ? Color.textDisabled : Color.textMain}>
        {description}
      </Text>
      <Range
        min={0}
        max={max}
        step={1}
        value={sliderValue}
        setValue={onSliderChange}
        valueLabel={sliderValue}
        leftLabel={leftLabel}
        rightLabel={rightLabel}
        isDisabled={isDisabled}
      />
    </Flex>
  </RulesSectionContainer>
);
